export const AIRulesLSKey = 'AIRulesLSKey'

export const AI_RULES_URL = 'https://wp.pl'

export const AI_LIST_LIMIT = 10

export const AI_WELCOME_MESSAGE_ID = 'welcome'
